export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 720;

// Isometric tile geometry. The provided tile PNGs are ~64x32 isometric.
export const TILE_W = 64;
export const TILE_H = 32;

// Chunk dimensions are intentionally small for a prototype — each chunk
// is a discrete "stage" the party fights across, not a streamed open world.
// Doubled from 28 — needs camera follow (M13) and viewport culling.
export const CHUNK_TILES_W = 56;
export const CHUNK_TILES_H = 56;

/** Vertical pixels per elevation level (negative; tiles render higher). */
export const ELEVATION_PX = 14;

export const COLORS = {
  bg: 0x0a0a0a,
  ui: '#e8e2d0',
  hp: 0x4caf50,
  hpBad: 0xc62828,
  morale: 0xffc107,
  text: '#f4ecd6',
  textDim: '#9a8f7a',
  panel: 0x12100c,
  panelBorder: 0x3a3327,
} as const;
